import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "app__info-popup-container info-popup-container" }
const _hoisted_2 = { class: "info-popup-container__product detail-container__product" }
const _hoisted_3 = { class: "info-popup-container__up detail-container__up" }
const _hoisted_4 = { class: "info-popup-container__swiper detail-container__swiper" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "info-popup-container__content-title detail-container__content-title" }
const _hoisted_7 = { class: "info-popup-container__weight detail-container__weight" }
const _hoisted_8 = { class: "info-popup-container__weight-text detail-container__weight-text" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "info-popup-container__profile detail-container__profile" }, null, -1)
const _hoisted_11 = { class: "info-popup-container__info" }
const _hoisted_12 = { class: "info-popup-container__title detail-container__title" }
const _hoisted_13 = {
  key: 0,
  class: "info-popup-container__sale-case detail-container__sale-case"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "info-popup-container__title-category detail-container__title-category" }
const _hoisted_16 = { class: "info-popup-container__price-category detail-container__price-category" }
const _hoisted_17 = { class: "info-popup-container__bottom detail-container__bottom" }
const _hoisted_18 = { class: "info-popup-container__btns detail-container__btns" }
const _hoisted_19 = {
  class: "info-popup-container__btn detail-container__btn detail-container__btn--black info-popup-container__btn--black",
  style: {"width":"50%"}
}
const _hoisted_20 = {
  key: 0,
  class: "info-popup-container__price detail-container__price"
}
const _hoisted_21 = { class: "info-popup-container__sale-price detail-container__sale-price" }
const _hoisted_22 = {
  key: 1,
  class: "info-popup-container__price detail-container__price"
}
const _hoisted_23 = {
  key: 1,
  class: "info-popup-container__sale-price detail-container__sale-price"
}
const _hoisted_24 = {
  key: 0,
  class: "loader"
}
const _hoisted_25 = {
  key: 1,
  class: "info-popup-container__btn-text detail-container__btn-text"
}
const _hoisted_26 = {
  key: 2,
  width: "18",
  height: "21",
  viewBox: "0 0 18 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<path d=\"M1.92816 2.14282L2.30631 5.35711M2.30631 5.35711L3.21388 13.0714H13.4996L16.071 5.35711H2.30631Z\" stroke=\"white\" stroke-width=\"1.28571\" stroke-linejoin=\"round\"></path><path d=\"M7.071 17.5714C7.071 18.2815 6.49537 18.8571 5.78529 18.8571C5.07521 18.8571 4.49957 18.2815 4.49957 17.5714C4.49957 16.8613 5.07521 16.2857 5.78529 16.2857C6.49537 16.2857 7.071 16.8613 7.071 17.5714Z\" fill=\"white\"></path><path d=\"M7.071 17.5714C7.071 18.2815 6.49537 18.8571 5.78529 18.8571C5.07521 18.8571 4.49957 18.2815 4.49957 17.5714C4.49957 16.8613 5.07521 16.2857 5.78529 16.2857C6.49537 16.2857 7.071 16.8613 7.071 17.5714Z\" stroke=\"white\" stroke-width=\"1.28571\" stroke-linejoin=\"round\"></path><path d=\"M13.4996 17.5714C13.4996 18.2815 12.924 18.8571 12.2139 18.8571C11.5038 18.8571 10.9282 18.2815 10.9282 17.5714C10.9282 16.8613 11.5038 16.2857 12.2139 16.2857C12.924 16.2857 13.4996 16.8613 13.4996 17.5714Z\" fill=\"white\"></path><path d=\"M13.4996 17.5714C13.4996 18.2815 12.924 18.8571 12.2139 18.8571C11.5038 18.8571 10.9282 18.2815 10.9282 17.5714C10.9282 16.8613 11.5038 16.2857 12.2139 16.2857C12.924 16.2857 13.4996 16.8613 13.4996 17.5714Z\" stroke=\"white\" stroke-width=\"1.28571\" stroke-linejoin=\"round\"></path>", 5)
const _hoisted_32 = [
  _hoisted_27
]
const _hoisted_33 = {
  key: 0,
  class: "info-popup-container__btn-text detail-container__btn-text"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.59L18 2Z",
    fill: "white"
  })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "13",
  viewBox: "0 0 20 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.96064 2.89996L3.07143 11.54H16.2959L18.1851 2.89996M4.96064 2.89996L5.27551 1.45996H18.5L18.1851 2.89996M4.96064 2.89996L10.7857 6.49996L18.1851 2.89996M0.5 2.17996H4.17347M1.28717 5.29996H3.49125M2.09184 8.33996H2.82653",
    stroke: "white"
  })
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "info-popup-container__description detail-container__description" }
const _hoisted_38 = {
  key: 0,
  class: "info-popup-container__text detail-container__text"
}
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 1,
  class: "info-popup-container__recipes detail-container__recipes"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", { class: "info-popup-container__caption detail-container__caption" }, " Рецепты приготовления ", -1)
const _hoisted_42 = { class: "info-popup-container__recipes-list detail-container__recipes-list" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "recipe__gradient" }, null, -1)
const _hoisted_46 = { class: "recipe__text" }
const _hoisted_47 = { class: "recipe__title" }
const _hoisted_48 = { class: "recipe__description" }
const _hoisted_49 = { class: "recipe__time" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "recipe__time-svg" }, null, -1)
const _hoisted_51 = { class: "recipe__group" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "recipe__group-svg" }, null, -1)
const _hoisted_53 = {
  key: 2,
  class: "info-popup-container__description-body detail-container__description-body"
}
const _hoisted_54 = {
  key: 0,
  class: "info-popup-container__methods detail-container__methods"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h3", { class: "info-popup-container__caption detail-container__caption" }, " Способы приготовления ", -1)
const _hoisted_56 = { class: "info-popup-container__methods-list detail-container__methods-list" }
const _hoisted_57 = {
  key: 0,
  class: "info-popup-container__svg--union"
}
const _hoisted_58 = {
  key: 1,
  class: "info-popup-container__svg--subtract"
}
const _hoisted_59 = {
  key: 2,
  class: "info-popup-container__svg--stove"
}
const _hoisted_60 = {
  key: 3,
  class: "info-popup-container__svg--pot"
}
const _hoisted_61 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_TheBeef = _resolveComponent("TheBeef")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_swiper, {
            pagination: {
              clickable: true,
            },
            modules: _ctx.modules,
            class: "cardMySwiper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayImages, (image, idx) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  class: "info-popup-container__image",
                  key: idx
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: image,
                      alt: _ctx.item.name
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              (_ctx.item.portions)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" × " + _toDisplayString(_ctx.item.portions), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.displayInfo), 1)
            ])
          ]),
          _createElementVNode("h2", _hoisted_12, [
            _createTextVNode(_toDisplayString(_ctx.item.name) + " ", 1),
            (_ctx.displayDiscountPercent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " -" + _toDisplayString(_ctx.displayDiscountPercent) + "% ", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.item.offers.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ error: _ctx.invalid }, "info-popup-container__offers detail-container__offers"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.offers, (offer, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    onClick: ($event: any) => (_ctx.changeSelectedOffer(offer)),
                    class: _normalizeClass([[
                {
                  'info-popup-container__offer-item--active-select':
                    offer.id == _ctx.selectedOffer.id && idx == 2,
                },
                {
                  'info-popup-container__offer-item--active-choise':
                    offer.id == _ctx.selectedOffer.id && idx == 1,
                },
                {
                  'info-popup-container__offer-item--active-prime':
                    offer.id == _ctx.selectedOffer.id && idx == 0,
                },
                { 'info-popup-container__offer-item--error': false },
              ], "info-popup-container__offer-item detail-container__offer-item"]),
                    key: idx
                  }, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(offer.name), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.priceFormat(offer.ratioPrice)), 1)
                  ], 10, _hoisted_14))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", _hoisted_19, [
            (_ctx.item.offers.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  true
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass([{
                  'info-popup-container__current-price--black detail-container__current-price--black': true,
                }, "info-popup-container__current-price detail-container__current-price"])
                      }, _toDisplayString(_ctx.displayPrice), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.displayDiscountPrice), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.item.offers.length < 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  true
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass([{
                  'info-popup-container__current-price--black detail-container__current-price--black': true,
                }, "info-popup-container__current-price detail-container__current-price"])
                      }, _toDisplayString(_ctx.displayPrice), 1))
                    : _createCommentVNode("", true),
                  true
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.displayDiscountPrice), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.quantity == 0 && _ctx.available)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "info-popup-container__btn info-popup-container__btn--green detail-container__btn detail-container__btn--green",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBasket()))
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                  : _createCommentVNode("", true),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "В корзину"))
                  : _createCommentVNode("", true),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_32))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.quantity != 0 && _ctx.available)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBasket())),
                class: "info-popup-container__btn info-popup-container__btn--add detail-container__btn detail-container__btn--add"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "В корзину"))
                  : _createCommentVNode("", true),
                _hoisted_34
              ]))
            : _createCommentVNode("", true),
          (!_ctx.available)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNotification(_ctx.item.id))),
                class: "info-popup-container__btn info-popup-container__btn--green detail-container__btn detail-container__btn--green"
              }, _hoisted_36))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      (_ctx.detailInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("p", {
              innerHTML: _ctx.detailInfo.description
            }, null, 8, _hoisted_39)
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailInfo && _ctx.detailInfo.recipes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("ul", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.recipes, (recipe) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "info-popup-container__recipes-item recipe detail-container__recipes-item",
                  key: recipe.id,
                  onClick: ($event: any) => (_ctx.showDetail(recipe))
                }, [
                  _createElementVNode("img", {
                    src: recipe.image,
                    alt: recipe.name
                  }, null, 8, _hoisted_44),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("h4", _hoisted_47, _toDisplayString(recipe.name), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", _hoisted_49, [
                        _hoisted_50,
                        _createTextVNode(" " + _toDisplayString(recipe.time) + " мин", 1)
                      ]),
                      _createElementVNode("span", _hoisted_51, [
                        _hoisted_52,
                        _createTextVNode(" × " + _toDisplayString(recipe.persons), 1)
                      ])
                    ])
                  ])
                ], 8, _hoisted_43))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_TheBeef, {
        piece: _ctx.item.piece
      }, null, 8, ["piece"]),
      (_ctx.detailInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            (_ctx.detailInfo.features && _ctx.detailInfo.features[1].valueCodes.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("ul", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.features[1].valueCodes, (feature, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "info-popup-container__methods-item detail-container__methods-item",
                        key: idx
                      }, [
                        (feature === 'frying')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                          : _createCommentVNode("", true),
                        (feature === 'grill')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_58))
                          : _createCommentVNode("", true),
                        (feature === 'roasting')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_59))
                          : _createCommentVNode("", true),
                        (feature === 'stewing')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.blocks, (block, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "info-popup-container__contains detail-container__contains",
                key: idx,
                innerHTML: block
              }, null, 8, _hoisted_61))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}